<template>
  <div class="app-layout">
    <div class="app-layout__header">
      <div class="container">
        <router-link to="/" class="logo">
          <img src="~@/assets/img/logo.png" alt="logo" />
        </router-link>
        <div class="app-layout__header-controls">
          <cart-control class="app-layout__header-control"></cart-control>
          <language-control
            class="app-layout__header-control"
          ></language-control>
        </div>
      </div>
    </div>
    <div class="app-layout__inner">
      <div class="container">
        <div class="app-layout__sidebar">
          <app-sidebar></app-sidebar>
        </div>
        <div class="app-layout__content">
          <slot />
        </div>
      </div>
    </div>
    <footer-block></footer-block>
  </div>
</template>

<script>
import AppSidebar from "@/components/app/AppSidebar";
import CartControl from "@/components/app/CartControl";
import LanguageControl from "@/components/app/LanguageControl";
import { UPDATE_CART_ITEMS_COUNT } from "@/store/action-types";
import { CartApi } from "@/office/cart/cart-api";
import Footer from "@/components/app/Footer";
export default {
  name: "AppLayout",
  components: { FooterBlock: Footer, LanguageControl, CartControl, AppSidebar },
  created() {},
  methods: {
    loadCartItemsCount() {
      new CartApi().getCartItemsCount().then(async (r) => {
        await this.$store.dispatch(UPDATE_CART_ITEMS_COUNT, r.data.items_count);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-layout {
  &__header {
    padding: 18px 0;

    .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 76px;
    }

    .logo {
      height: 60px;
      padding: 5px 0;

      img {
        height: 100%;
      }
    }

    &-controls {
      display: flex;
      align-items: center;
    }

    &-control {
      margin-right: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__sidebar {
    width: 160px;
    margin-right: 16px;
    flex-shrink: 0;
    flex-grow: 0;
  }

  &__inner {
    .container {
      display: flex;
      align-items: flex-start;
    }
  }

  &__content {
    flex-grow: 1;
    flex-shrink: 1;
    width: calc(100% - 176px);
  }
}
</style>
